var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.592 2.914a13.333 13.333 0 1114.815 22.173A13.333 13.333 0 016.592 2.914zM17.625 9.72l-5.72 5.733-2.2-2.2a1.332 1.332 0 10-1.88 1.88l3.134 3.147a1.333 1.333 0 001.88 0l6.666-6.667a1.332 1.332 0 00-.94-2.28c-.352 0-.69.139-.94.387z",
    fill: "#00C48C"
  })));
}
export default SvgSuccess;